import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/home'
import store from '../store'
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    component: HomeIndex,
    children: [
      { path: '/', component: () => import('@/views/index') },
      { path: '/about', component: () => import('@/views/about') },
      { path: '/list', component: () => import('@/views/list') },
      { path: '/registration', component: () => import('@/views/registration') },
      { path: '/raceinfo', component: () => import('@/views/raceinfo') },
      { path: '/news', component: () => import('@/views/news') },
      { path: '/partner', component: () => import('@/views/partner') },
      { path: '/info', component: () => import('@/views/info') },
      { path: '/alipay', component: () => import('@/views/alipay') },
      { path: '/wxpay', component: () => import('@/views/wxpay') },
      { path: '/payment', component: () => import('@/views/payment') },
      { path: '/orderdetails', component: () => import('@/views/orderdetails') },
      { path: '/questions', component: () => import('@/views/questions') },
      { path: '/results', component: () => import('@/views/raceresult') },
      { path: '/startlist', component: () => import('@/views/registereduser') },
      { path: '/certificates', component: () => import('@/views/racecertificate') },
      { path: '/shops', component: () => import('@/views/raceinfo') },
      { path: '/contactus', component: () => import('@/views/contactus') },

      { path: '/messageBoard', component: () => import('@/views/messageBoard') },
      { path: '/datapolicy', component: () => import('@/views/datapolicy') },
      { path: '/rules', component: () => import('@/views/rules') },
      { path: '/sup-rules', component: () => import('@/views/suprules') },
      { path: '/raceguide', component: () => import('@/views/raceguide') },
      { path: '/terms', component: () => import('@/views/terms') },
      { path: '/safety', component: () => import('@/views/safety') },
      { path: '/tojishui', component: () => import('@/views/tojishui') },
    ]
  },
  { path: '/404', component: () => import('@/views/404') },
  { path: '/500', component: () => import('@/views/500') },
  { path: '/502', component: () => import('@/views/502') },
  { path: '/*', component: () => import('@/views/404') }

]

const router = new Router({
  mode: 'history',
  routes: constantRouterMap
})

// router.beforeEach((to, from, next) => {
//   console.log("获取路径", to, from)
//   console.log("------------")
//   console.log(store.state.app.webNavbarList)
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js